import { render, staticRenderFns } from "./RankByCollegeCard.vue?vue&type=template&id=5a754579"
import script from "./RankByCollegeCard.vue?vue&type=script&lang=js"
export * from "./RankByCollegeCard.vue?vue&type=script&lang=js"
import style0 from "./RankByCollegeCard.vue?vue&type=style&index=0&id=5a754579&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports